'use client';

import type * as React from 'react';
import { PaletteErrorBoundary } from '@/components/command-palette/palette-error-boundary';
import { HeaderActionsProvider } from './_header-actions';
import { DashboardLayoutHeader } from './dashboard-layout-header';
import { SysCommandPalette } from './sys/_command-palette';

export function DashboardLayoutContent({
  children,
}: Readonly<{
  children: React.ReactNode;
}>): React.ReactNode {
  return (
    <HeaderActionsProvider>
      <DashboardLayoutHeader />
      <PaletteErrorBoundary>
        <SysCommandPalette />
      </PaletteErrorBoundary>
      <div className="dashboard-content flex min-w-0 flex-1 flex-col gap-4 p-4 md:gap-6 md:p-6 text-foreground">
        {children}
      </div>
    </HeaderActionsProvider>
  );
}
